var render = function render(){var _vm=this,_c=_vm._self._c;return _c('settings-wrapper',{attrs:{"title":"Space settings","section":"Large file storage"}},[_c('the-space-LFS',{attrs:{"space-id":_vm.activeSpaceId,"is-space-admin-override":_vm.isSpaceAdmin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }